import { render, staticRenderFns } from "./Corridor.vue?vue&type=template&id=696cde29&scoped=true&"
import script from "./Corridor.vue?vue&type=script&lang=ts&"
export * from "./Corridor.vue?vue&type=script&lang=ts&"
import style0 from "./Corridor.vue?vue&type=style&index=0&id=696cde29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696cde29",
  null
  
)

export default component.exports